import { memo } from 'react';

import { Box, Image } from '@chakra-ui/react';

interface CardImageProps {
  src: string;
  alt: string;
}

const CardImage = ({ src, alt }: CardImageProps) => (
  <Box w='100%' height={{ base: '45px', lg: '57px' }}>
    <Image
      height={{ base: '45px', lg: '57px' }}
      src={src}
      alt={alt}
      style={{ objectFit: 'contain', objectPosition: 'left' }}
    />
  </Box>
);

export default memo(CardImage);
